import { FC } from "react";
import { useTranslation } from "react-i18next";
import { PageContent } from "@/core/layout/PageContent/PageContent.tsx";
import Section from "@/core/components/Section/Section.tsx";
import { BaseHeadline } from "@/core/components/BaseHeadline/BaseHeadline.tsx";
import { BaseText } from "@/core/components/BaseText/BaseText.tsx";
import { ButtonPrimary } from "@/core/components/ButtonPrimary/ButtonPrimary.tsx";
import { ButtonSecondary } from "@/core/components/ButtonSecondary/ButtonSecondary.tsx";
import { ApplicationError } from "@/core/api/model/error.ts";
import { ensureExhaustive } from "@/core/utils/helper.ts";

const CONTACT_EMAIL = "kontakt@bfit-bund.de";

export interface ErrorPageProps {
    error: Exclude<ApplicationError, typeof ApplicationError.NONE>;
}

export const ErrorPage: FC<ErrorPageProps> = ({ error }) => {
    const { t: translation } = useTranslation();
    let headline: string;
    let description: string;
    switch (error) {
        case ApplicationError.PAGE_NOT_FOUND:
            headline = translation("ERROR_PAGE_HEADLINE_NOT_FOUND");
            description = translation("ERROR_PAGE_DESCRIPTION_NOT_FOUND");
            break;
        case ApplicationError.UNKNOWN:
            headline = translation("ERROR_PAGE_HEADLINE_GENERIC");
            description = translation("ERROR_PAGE_DESCRIPTION_GENERIC");
            break;
        default:
            ensureExhaustive(error);
    }
    const reloadPage = () => window.location.reload();
    const openContact = () => (window.location.href = `mailto:${CONTACT_EMAIL}`);
    return (
        <PageContent>
            <Section>
                <BaseHeadline text={headline} />
                <BaseText>{description}</BaseText>
                <div className="d-flex justify-content-end gap-2 mt-4">
                    <ButtonPrimary label={translation("ERROR_PAGE_RETRY")} onClick={reloadPage} />
                    <ButtonSecondary label={translation("ERROR_PAGE_CONTACT")} onClick={openContact} />
                </div>
            </Section>
        </PageContent>
    );
};

export const Component = ErrorPage;
